import React, { useState } from 'react';
import axios from 'axios';
import '../utils/Consultas.css';
import logo from '../components/public/llave.jpg';

const apiUrl =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:4000'
    : process.env.REACT_APP_API_URL;

const Consultas = () => {
  const [codigoMedidor, setCodigoMedidor] = useState('');
  const [cedulaCliente, setCedulaCliente] = useState('');
  const [consumos, setConsumos] = useState([]);
  const [mensaje, setMensaje] = useState('');
  const [colorMensaje, setColorMensaje] = useState('');

  const handleCodigoMedidorChange = (e) => setCodigoMedidor(e.target.value);
  const handleCedulaClienteChange = (e) => setCedulaCliente(e.target.value);

  const consultarConsumo = async () => {
    setConsumos([]);
    setMensaje('');
    setColorMensaje('');

    if (!codigoMedidor || !cedulaCliente) {
      setMensaje('Por favor ingrese ambos campos.');
      setColorMensaje('#f8d7da');
      return;
    }

    try {
      const response = await axios.post(apiUrl + '/pagos/verificar-datos', {
        codigoMedidor,
        cedulaCliente,
      });

      if (response.data && Array.isArray(response.data)) {
        const consumosPendientes = response.data.filter((consumo) => consumo.estado === 'PENDIENTE');
        if (consumosPendientes.length === 0) {
          setMensaje('No existe deuda pendiente.');
          setColorMensaje('#d4edda');
        } else {
          setConsumos(consumosPendientes);
          setMensaje('');
        }
      } else {
        setMensaje('No se encontraron consumos para el cliente.');
        setColorMensaje('#f8d7da');
      }
    } catch (error) {
      setMensaje('Datos incorrectos. Intente nuevamente.');
      setColorMensaje('rgba(248, 215, 218, 0.5)');
    }
  };

  return (
    <div className="consultas-panel">
      <section className="consultas-fixed">
        <div className="intro-imaje">
          <img src={logo} alt="Logo" />
        </div>
        <br />
        <h2>Consulta tu consumo y pagos pendientes</h2>
        <div className="form-consulta">
          <div>
            <label htmlFor="codigoMedidor">Código de Medidor:</label>
            <input
              type="text"
              id="codigoMedidor"
              value={codigoMedidor}
              onChange={handleCodigoMedidorChange}
              placeholder="Ingrese el código del medidor"
              autoComplete="off"
            />
          </div>
          <div>
            <label htmlFor="cedulaCliente">Cédula del Cliente:</label>
            <input
              type="text"
              id="cedulaCliente"
              value={cedulaCliente}
              onChange={handleCedulaClienteChange}
              placeholder="Ingrese la cédula del cliente"
              autoComplete="off"
            />
          </div>
          <button onClick={consultarConsumo}>Consultar</button>
        </div>

        {/* Mensaje de validación o resultado */}
        {mensaje && (
          <div
            style={{
              backgroundColor: colorMensaje,
              color: '#003366',
              padding: '10px',
              borderRadius: '5px',
              textAlign: 'center',
              marginTop: '15px',
              fontWeight: 'bold',
            }}
          >
            {mensaje}
          </div>
        )}

        <section className="consultas-table">
        {consumos.length > 0 && (
          <div style={{ overflowX: 'auto' }}>
            <table className="pagos-table">
              <thead>
                <tr>
                  <th>Código de Medidor</th>
                  <th>Lectura Anterior</th>
                  <th>Lectura Actual</th>
                  <th>Mes</th>
                  <th>Exceso</th>
                  <th>Mora</th>
                  <th>Sub Total</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                {consumos.map((consumo, index) => (
                  <tr key={index}>
                    <td data-label="Código de Medidor">{consumo.codigo_medidor}</td>
                    <td data-label="Lectura Anterior">{consumo.lectura_anterior}</td>
                    <td data-label="Lectura Actual">{consumo.lectura_actual}</td>
                    <td data-label="Mes">{new Date(consumo.fecha_consumo).toLocaleString('es-EC', { month: 'long', year: 'numeric' })}</td>
                    <td data-label="Exceso">{consumo.exceso}</td>
                    <td data-label="Mora">{consumo.mora}</td>
                    <td data-label="Sub Total">{consumo.total_pagar}</td>
                    <td data-label="Estado">{consumo.estado}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>

        {/* Información extra */}
        <div className="info-adicional">
          <h3>¿Cómo usar este formulario?</h3>
          <p>
            Ingrese el código de medidor y su cédula para consultar si tiene consumos pendientes de pago.
            Si tiene dudas, por favor comuníquese con nuestra línea de atención al cliente o visite una de nuestras oficinas.
          </p>
          <p>
            Recuerde que la información mostrada es actualizada diariamente y puede variar en función de los consumos realizados.
          </p>
        </div>
      </section>

     
    </div>
  );
};

export default Consultas;
